var _rect, _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecure2 = function SvgSecure2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 182 50"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 50,
    x: 61,
    fill: "#fff",
    rx: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "M93.023 27.441q0 2.262-1.64 3.528-1.64 1.265-4.453 1.265-3.047 0-4.688-.785v-1.922a12.3 12.3 0 0 0 2.297.703 12 12 0 0 0 2.461.258q1.992 0 3-.75 1.008-.761 1.008-2.11 0-.89-.364-1.452-.35-.575-1.195-1.055-.832-.48-2.543-1.09-2.39-.855-3.422-2.027-1.02-1.171-1.02-3.059 0-1.98 1.49-3.152 1.487-1.172 3.937-1.172 2.555 0 4.699.938l-.621 1.734q-2.122-.89-4.125-.89-1.583 0-2.473.679-.89.68-.89 1.887 0 .89.328 1.465.327.562 1.101 1.043.785.468 2.39 1.043 2.697.96 3.704 2.062 1.02 1.102 1.02 2.86m8.637 4.793q-2.847 0-4.5-1.734-1.64-1.734-1.64-4.816 0-3.105 1.523-4.934 1.534-1.828 4.113-1.828 2.415 0 3.821 1.594 1.406 1.581 1.406 4.183v1.23h-8.848q.06 2.263 1.137 3.434 1.09 1.173 3.058 1.172 2.074 0 4.102-.867v1.734a10 10 0 0 1-1.957.633q-.914.2-2.215.2m-.527-11.683q-1.547 0-2.473 1.008-.915 1.007-1.078 2.789h6.715q0-1.84-.82-2.813-.821-.984-2.344-.984m13.711 11.683q-2.79 0-4.324-1.71-1.524-1.723-1.524-4.864 0-3.222 1.547-4.98 1.559-1.758 4.43-1.758.925 0 1.851.2.926.198 1.453.468l-.597 1.652a9 9 0 0 0-1.407-.422 6 6 0 0 0-1.347-.175q-3.915 0-3.914 4.992 0 2.367.949 3.633.961 1.265 2.836 1.265 1.605 0 3.293-.691v1.722q-1.29.669-3.246.668m8.133-13.078v8.332q0 1.57.714 2.344.715.773 2.239.773 2.015 0 2.941-1.101.938-1.102.938-3.598v-6.75h1.945V32h-1.606l-.281-1.723h-.105a3.87 3.87 0 0 1-1.664 1.453q-1.055.504-2.414.504-2.345 0-3.516-1.113-1.16-1.114-1.16-3.562v-8.403zm18.773-.234q.855 0 1.535.14l-.269 1.805q-.797-.176-1.407-.176-1.558 0-2.671 1.266-1.102 1.266-1.102 3.152V32h-1.945V19.156h1.605l.223 2.38h.093q.715-1.255 1.723-1.934a3.88 3.88 0 0 1 2.215-.68m9.363 13.312q-2.847 0-4.5-1.734-1.64-1.734-1.64-4.816 0-3.105 1.523-4.934 1.536-1.828 4.113-1.828 2.415 0 3.821 1.594 1.406 1.581 1.406 4.183v1.23h-8.848q.058 2.263 1.137 3.434 1.09 1.173 3.059 1.172 2.074 0 4.101-.867v1.734a10 10 0 0 1-1.957.633q-.914.2-2.215.2m-.527-11.683q-1.547 0-2.473 1.008-.913 1.007-1.078 2.789h6.715q0-1.84-.82-2.813-.82-.984-2.344-.984"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 120,
    height: 120,
    x: -35,
    y: -35
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(17.5px)",
      clipPath: "url(#Secure2_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 35
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#204969",
    rx: 25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    stroke: "url(#Secure2_svg__b)",
    strokeLinecap: "round",
    strokeOpacity: 0.5,
    rx: 24.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.976 17.192v8.943c0 1.127.27 2.136.825 3.085 1.34 2.285 4.358 4.102 7.022 5.704q.61.366 1.172.711c.495-.308.999-.612 1.486-.907.45-.27.914-.552 1.365-.832 3.259-2.024 6.182-4.14 6.182-7.763l-.001-8.941L25 14.11zm14.343 5.953v5.933c0 .665-.537 1.208-1.192 1.208h-8.254a1.204 1.204 0 0 1-1.192-1.208v-5.933c0-.665.536-1.208 1.191-1.208h8.255c.656 0 1.192.543 1.192 1.208m-1.889-3.343V21.3h-1.525v-1.498c0-1.063-.857-1.932-1.906-1.932s-1.906.87-1.906 1.932V21.3h-1.525v-1.498c0-1.913 1.544-3.478 3.43-3.478 1.888 0 3.432 1.565 3.432 3.478m6.793-4.31L25 12l-10.224 3.49c-.471.161-.776.59-.776 1.095v9.55c0 6.228 6.394 8.812 11 11.865 4.606-3.052 11-5.637 11-11.865v-9.549c0-.505-.304-.934-.776-1.095zm-.567 10.644c0 1.848-.701 3.49-2.144 5.02-1.235 1.31-2.822 2.342-4.34 3.285-.456.283-.92.564-1.37.836-.54.326-1.1.663-1.642 1.004a.31.31 0 0 1-.328 0 104 104 0 0 0-1.332-.808c-2.73-1.642-5.822-3.502-7.242-5.927a6.57 6.57 0 0 1-.915-3.41l.003-9.173a.32.32 0 0 1 .214-.301l9.341-3.19a.3.3 0 0 1 .2 0l9.342 3.188a.32.32 0 0 1 .214.302v9.174m-10.66-.95A1.01 1.01 0 0 1 25 24.169a1.01 1.01 0 0 1 1.003 1.017c0 .346-.17.65-.43.834v1.457c0 .32-.257.581-.572.581a.58.58 0 0 1-.573-.58V26.02a1.02 1.02 0 0 1-.429-.834z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Secure2_svg__b",
    x1: -0.156,
    x2: 24.844,
    y1: 0.156,
    y2: 25.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Secure2_svg__a",
    transform: "translate(35 35)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25
  })))));
};
export default SvgSecure2;